exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/marcro-data-econ/marcro-data-econ.component.scss
// module id = ../../../../../src/app/market-level/marcro-data-econ/marcro-data-econ.component.scss
// module chunks = main